module.exports = __webpack_public_path__ + "static/om-0e22e9d8538660aded82b54e8f75c6b0.svg";